export default __webpack_public_path__ + "static/media/blockchain-2-30-min.37fd12a2.png";